import { ReactElement, forwardRef } from 'react';
import cn from 'classnames';
import styles from './CheckButton.module.scss';
import { ReactComponent as Checked } from '../../images/vectors/checked.svg';
import { getDataTest } from '../../utils/dataTests';

export interface CheckButtonProps {
    checked: boolean;
    size?: 'small' | 'large';
    onClick?: () => void;
    className?: string;
    tabIndex?: number;
    onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}

export const CheckButton = forwardRef<HTMLDivElement, CheckButtonProps>(
    ({ checked, className, size = 'large', onClick, tabIndex, onKeyDown, ...props }, ref): ReactElement => (
        <div
            ref={ref}
            tabIndex={tabIndex}
            onClick={onClick}
            onKeyDown={onKeyDown}
            className={cn(styles.button, checked && styles.isActive, size && styles[size], className)}
            data-test={getDataTest(props)}
        >
            <Checked className={cn(checked && styles.checkIconVisible, styles.checkIcon)} />
        </div>
    )
);
CheckButton.displayName = 'CheckButton';
